import {
  SlotCapacity,
  SlotCapacityStatus,
} from 'domains-reservable-availability';

import { ChipSubLabelVariant } from '.';

type ChipCapacityProps = {
  subLabel: string | undefined;
  subLabelVariant: ChipSubLabelVariant;
  disabled: boolean;
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

const VARIANT_BY_STATUS: Record<SlotCapacityStatus, ChipSubLabelVariant> = {
  [SlotCapacityStatus.Available]: 'default',
  [SlotCapacityStatus.Low]: 'warning',
  [SlotCapacityStatus.Critical]: 'critical',
  [SlotCapacityStatus.Full]: 'default',
  [SlotCapacityStatus.UserCapReached]: 'default',
};

function getSubLabel(
  status: SlotCapacityStatus,
  remainingSpots: number | null,
  t: TranslateFn
): string | undefined {
  if (status === SlotCapacityStatus.Full) {
    return t('web.reservable.full');
  }

  if (status === SlotCapacityStatus.Available || remainingSpots == null) {
    return undefined;
  }

  return t('web.reservable.spotsLeft', { count: remainingSpots });
}

/**
 * Turns the domain capacity verdict into the copy and styling a chip renders.
 * Keeps the i18n keys in the web layer, where they belong.
 */
export function getChipCapacityProps(
  { status, remainingSpots, isBookable }: SlotCapacity,
  t: TranslateFn
): ChipCapacityProps {
  return {
    subLabel: getSubLabel(status, remainingSpots, t),
    subLabelVariant: VARIANT_BY_STATUS[status],
    disabled: !isBookable,
  };
}
